import {
  WSAlert,
  WSAlertProps,
  WSElementProps
} from "@wingspanhq/fe-component-library";
import React, { useMemo, useRef, useState } from "react";

import { ErrorContext } from "../../utils/errorMap";
import { resolveErrorMessage } from "../../utils/resolveErrorMessage";

export type ErrorAlertProps = {
  error?: unknown;
  context: ErrorContext;
  forceShowRawError?: boolean;
} & WSElementProps &
  WSAlertProps;

export const ErrorAlert: React.FC<ErrorAlertProps> = props => {
  const { error, context, forceShowRawError, ...alertProps } = props;
  const [isDismissed, setIsDismissed] = useState(false);
  const prevErrorRef = useRef(error);

  if (error !== prevErrorRef.current) {
    prevErrorRef.current = error;
    if (isDismissed) {
      setIsDismissed(false);
    }
  }

  const message = useMemo(
    () => resolveErrorMessage({ error, context, forceShowRawError }),
    [context, error, forceShowRawError]
  );

  if (!error || isDismissed) {
    return null;
  }

  return (
    <WSAlert
      {...alertProps}
      theme="error"
      icon="info-circle"
      data-testid="error-alert"
    >
      <>{message}</>
    </WSAlert>
  );
};
